/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
:host {
  display: block;
  width: 100%;
  margin: auto 0;
  --ux-skeleton-height: 35px;
  --ux-skeleton-width: 100%;
  --ux-skeleton-margin-bottom: 10px;
  --ux-skeleton-animation-duration: 2s;
  --ux-skeleton-animation-duration-reduced: 10s;
}

@media (prefers-reduced-motion) {
  .item {
    animation-duration: var(--ux-skeleton-animation-duration-reduced);
  }
}
.item {
  height: var(--ux-skeleton-height);
  --loader-background-color: #EEEEEE;
  --loader-highlight-color: #DEDEDE;
  background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
  background-size: 200% 100%;
  animation: loading var(--ux-skeleton-animation-duration) infinite ease-in-out;
  width: var(--ux-skeleton-width);
  margin-bottom: var(--ux-skeleton-margin-bottom);
}
.item:last-of-type {
  margin-bottom: unset;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}